<template>
  <HrPageLayout title="Appointment Management" subtitle="Handle appointment offers and onboarding" :breadcrumb-items="[{ label: 'Recruitment' }, { label: 'Appointments' }]">
    <template #header-actions>
      <div class="hr-flex hr-flex-center hr-gap-2">
        <button class="hr-btn" @click="refresh">Refresh</button>
      </div>
    </template>

    <div class="hr-chart-card hr-mt-3">
      <div class="hr-chart-header">
        <h5 class="hr-chart-title"><i class="bx bx-user-check"></i> Appointments</h5>
      </div>
      <div class="hr-chart-body">
        <div v-if="loading" class="hr-loading-state">
          <div class="hr-spinner"></div>
          <p>Loading appointments...</p>
        </div>
        <div v-else-if="items.length === 0" class="hr-empty-state">
          <i class="bx bx-file"></i>
          <h5>No appointments</h5>
          <p>Approved candidates will have appointments listed here.</p>
        </div>
        <div v-else class="hr-table-wrapper">
          <table class="hr-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Candidate</th>
                <th>Vacancy</th>
                <th>Start Date</th>
                <th style="text-align:center">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(a, i) in items" :key="a.id">
                <td>{{ i + 1 }}</td>
                <td>{{ a.candidate }}</td>
                <td>{{ a.vacancy }}</td>
                <td>{{ a.startDate }}</td>
                <td style="text-align:center"><span class="hr-badge hr-badge-success">{{ a.status }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </HrPageLayout>
</template>

<script>
/* eslint-disable */
import HrPageLayout from "@/components/hrActions/HrPageLayout.vue";
import { authUrl, execute } from "@/api";

export default {
  name: 'AppointmentManagement',
  components: { HrPageLayout },
  data() { return { loading: false, items: [] }; },
  mounted() { this.fetchAppointments(); },
  methods: {
    async fetchAppointments() {
      this.loading = true;
      const data = new FormData();
      data.append('function', 'getAppointments');
      try {
        const res = await execute(data, authUrl);
        if (res.data.success) this.items = res.data.data.items || [];
      } catch (e) { console.error(e); }
      this.loading = false;
    },
    refresh() { this.fetchAppointments(); }
  }
}
</script>
